import { videoShapeMigrations, videoShapeProps } from "@tldraw/tlschema";
import { defineShape } from "../../../config/defineShape.mjs";
import { VideoShapeUtil } from "./VideoShapeUtil.mjs";
const VideoShape = defineShape("video", {
  util: VideoShapeUtil,
  props: videoShapeProps,
  migrations: videoShapeMigrations
});
export {
  VideoShape
};
//# sourceMappingURL=VideoShape.mjs.map
